import { scrollToWithOffset } from './bundler-utils.js';

/**
 * Function to create a progress bar
 * @param {Object} bundle - The bundle object
 */
export function createProgressBar(bundle) {
  console.log("▶ createProgressBar called");
  const container = document.querySelector(".bndlr-sections-main-container");
  const sectionsContainer = document.querySelector(".bndlr-sections-container");

  if (bundle && bundle.sections && container) {
    var progressBar = document.createElement("div");
    progressBar.className = "bndlr-progress-bar";

    var html = "";
    html += '<div class="bndlr-progress-bar__inner">';
    html +=
      '  <div class="bndlr-progress-bar__bubbles" style="grid-template-columns: repeat(' +
      (bundle.sections.length + 1) +
      ', 1.5rem);">';
    for (var i = 0; i < bundle.sections.length; i++) {
      var section = bundle.sections[i];
      html +=
        '    <button class="bndlr-progress-bar__bubble bndlr-progress-bar__bubble-' +
        (i + 1);
      if (i === 0) {
        html += " bndlr-progress-bar__bubble--active";
      }
      html += '">';
      html += '      <div class="bndlr-progress-bar__bubble-inner">';
      html +=
        '        <svg class="bndlr-progress-bar__bubble-checked" xmlns="http://www.w3.org/2000/svg" class="sc-a8a1e305-0 ehHIPR" viewBox="0 0 42 42" width="100%" height="100%" fill="white">';
      html += "          <title>Haken</title>";
      html +=
        '          <path d="M14.53 32.262c-.475 0-.897-.211-1.161-.528l-7.965-8.65c-.58-.633-.527-1.636.106-2.216.633-.58 1.635-.527 2.215.106l6.857 7.437 18.99-18.936c.632-.633 1.634-.633 2.215 0 .632.633.632 1.635 0 2.215l-20.15 20.097c-.264.316-.686.475-1.108.475z" fill="rgb(51, 51, 51)"></path>';
      html += "        </svg>";
      html +=
        '        <span class="bndlr-progress-bar__bubble-number">' +
        (i + 1) +
        "</span>";
      html += "      </div>";
      html += "    </button>";
    }
    html +=
      '      <button class="bndlr-progress-bar__bubble bndlr-progress-bar__bubble-' +
      (i + 1) +
      '">';
    html += '        <div class="bndlr-progress-bar__bubble-inner">';
    html +=
      '          <svg class="bndlr-progress-bar__bubble-checked" xmlns="http://www.w3.org/2000/svg" class="sc-a8a1e305-0 ehHIPR" viewBox="0 0 42 42" width="100%" height="100%" fill="white">';
    html += "            <title>Haken</title>";
    html +=
      '            <path d="M14.53 32.262c-.475 0-.897-.211-1.161-.528l-7.965-8.65c-.58-.633-.527-1.636.106-2.216.633-.58 1.635-.527 2.215.106l6.857 7.437 18.99-18.936c.632-.633 1.634-.633 2.215 0 .632.633.632 1.635 0 2.215l-20.15 20.097c-.264.316-.686.475-1.108.475z" fill="rgb(51, 51, 51)"></path>';
    html += "          </svg>";
    html +=
      '          <span class="bndlr-progress-bar__bubble-number">' +
      (i + 1) +
      "</span>";
    html += "        </div>";
    html += "      </button>";
    html +=
      '      <progress class="bndlr-progress-bar__bar" max="100" value="0"></progress>';
    html += "  </div>";
    html +=
      '  <div class="bndlr-progress-bar__steps" style="grid-template-columns: repeat(' +
      (bundle.sections.length + 1) +
      ', 1.5rem);">';
    for (var i = 0; i < bundle.sections.length; i++) {
      var section = bundle.sections[i];
      html +=
        '    <div class="bndlr-progress-bar__step bndlr-progress-bar__step-' +
        (i + 1);
      if (i === 0) {
        html += " bndlr-progress-bar__step--active";
      }
      html += '">';
      html +=
        '      <span class="bndlr-progress-bar__step-title">' +
        section.name +
        "</span>";
      html += "    </div>";
    }
    html +=
      '    <div class="bndlr-progress-bar__step bndlr-progress-bar__step-' +
      (i + 1) +
      '">';
    ('">');
    html +=
      '      <span class="bndlr-progress-bar__step-title">Zusammenfassung</span>';
    html += "    </div>";
    html += "  </div>";
    html += "</div>";

    progressBar.innerHTML = html;

    container.insertBefore(progressBar, sectionsContainer);

    const bubbleButtons = progressBar.querySelectorAll(
      ".bndlr-progress-bar__bubble"
    );

    bubbleButtons.forEach((bubble, index) => {
      bubble.addEventListener("click", () => {
        if (index === bubbleButtons.length - 1) {
          // Letzter Bubble → zur Zusammenfassung scrollen
          const summary = document.querySelector(
            ".bndlr-sections-status-container"
          );
          if (summary) {
            scrollToWithOffset(summary, 150);
          }
        } else {
          // Sonst → zur zugehörigen Section scrollen
          const section = document.querySelector(
            `.bndlr-sectioned-section[data-bundler-section="${index}"]`
          );
          if (section) {
            scrollToWithOffset(section, 150);
          }
        }
      });
    });
  }
}

/**
 * Function to update the progress bar
 */
export function updateProgressBar() {
  console.log("▶ updateProgressBar called");
  const progressBar = document.querySelector(".bndlr-progress-bar");
  const progress = progressBar.querySelector("progress");
  const bubbles = progressBar.querySelectorAll(".bndlr-progress-bar__bubble");

  const sections = document.querySelectorAll(".bndlr-sectioned-section");

  sections.forEach((section) => {
    const sectionNumber = parseInt(
      section.getAttribute("data-bundler-section"),
      10
    );
    const sectionFullfilled = section.getAttribute(
      "data-requirements-fulfilled"
    );
    const bubbleNumber = sectionNumber + 1;

    const bubble = progressBar.querySelector(
      `.bndlr-progress-bar__bubble-${bubbleNumber}`
    );

    if (sectionFullfilled === "true") {
      bubble.classList.add("bndlr-progress-bar__bubble--fullfilled");
      bubble.classList.remove("bndlr-progress-bar__bubble--active");

      if (bubbleNumber < bubbles.length) {
        const nextBubble = progressBar.querySelector(
          `.bndlr-progress-bar__bubble-${bubbleNumber + 1}`
        );
        nextBubble.classList.add("bndlr-progress-bar__bubble--active");

        const nextSection = document.querySelector(
          `.bndlr-sectioned-section[data-bundler-section="${
            sectionNumber + 1
          }"]`
        );

        const activeElement = document.activeElement;
        const activeSection = activeElement?.closest(
          ".bndlr-sectioned-section"
        );

        if (nextSection && nextSection !== activeSection) {
          scrollToWithOffset(nextSection, 150);
        } else if (!nextSection) {
          const summary = document.querySelector(
            ".bndlr-sections-status-container"
          );
          if (summary && summary !== activeSection) {
            scrollToWithOffset(summary, 150);
          }
        }
      }
    } else {
      // bubble.classList.remove("bndlr-progress-bar__bubble--active");
      if (bubbleNumber < bubbles.length) {
        const nextBubble = progressBar.querySelector(
          `.bndlr-progress-bar__bubble-${bubbleNumber + 1}`
        );
        nextBubble.classList.remove("bndlr-progress-bar__bubble--fullfilled");
      }
    }
    // Update Step
    const step = progressBar.querySelector(
      `.bndlr-progress-bar__step-${bubbleNumber}`
    );
    if (sectionFullfilled === "true") {
      step.classList.add("bndlr-progress-bar__step--fullfilled");
      step.classList.remove("bndlr-progress-bar__step--active");
      if (bubbleNumber < bubbles.length) {
        const nextStep = progressBar.querySelector(
          `.bndlr-progress-bar__step-${bubbleNumber + 1}`
        );
        nextStep.classList.add("bndlr-progress-bar__step--active");
      }
    } else {
      if (bubbleNumber < bubbles.length) {
        const nextStep = progressBar.querySelector(
          `.bndlr-progress-bar__step-${bubbleNumber + 1}`
        );
        nextStep.classList.remove("bndlr-progress-bar__step--fullfilled");
      }
    }
    // Update Progress
    const totalBubbles = progressBar.querySelectorAll(
      ".bndlr-progress-bar__bubble"
    ).length;
    const activeBubble = progressBar.querySelector(
      ".bndlr-progress-bar__bubble--active"
    );
    const lastActiveBubbleIndex = Array.from(bubbles).indexOf(activeBubble);
    const percentage = (lastActiveBubbleIndex / (totalBubbles - 1)) * 100;
    progress.value = percentage;

    if (sectionFullfilled !== "true") {
      bubble.classList.remove("bndlr-progress-bar__bubble--fullfilled");
      bubble.classList.add("bndlr-progress-bar__bubble--active");

      step.classList.remove("bndlr-progress-bar__step--fullfilled");
      step.classList.add("bndlr-progress-bar__step--active");

      const nextStep = progressBar.querySelector(
        `.bndlr-progress-bar__step-${bubbleNumber + 1}`
      );
      const nextBubble = progressBar.querySelector(
        `.bndlr-progress-bar__bubble-${bubbleNumber + 1}`
      );
      if (nextStep)
        nextStep.classList.remove(
          "bndlr-progress-bar__step--active",
          "bndlr-progress-bar__step--fullfilled"
        );
      if (nextBubble)
        nextBubble.classList.remove(
          "bndlr-progress-bar__bubble--active",
          "bndlr-progress-bar__bubble--fullfilled"
        );
    }
  });

  const activeElement = document.activeElement;
  const activeSection = activeElement?.closest(".bndlr-sectioned-section");

  const firstUnfulfilled = Array.from(sections).find((section) => {
    return section.getAttribute("data-requirements-fulfilled") !== "true";
  });

  if (firstUnfulfilled && firstUnfulfilled !== activeSection) {
    scrollToWithOffset(firstUnfulfilled, 150);
  }
}

/**
 * Function to update the section counters
 * @param {Object} bundle - The bundle object
 */
export function updateSectionCounters(bundle) {
  const sections = document.querySelectorAll(".bndlr-sectioned-section");

  sections.forEach((section) => {
    const sectionIndex = parseInt(
      section.getAttribute("data-bundler-section"),
      10
    );
    const sectionConfig = bundle.sections[sectionIndex];
    const sectionProducts = document.querySelector(
      `.bndlr-sectioned-section-status[data-bundler-section-status="${sectionIndex}"]`
    );

    if (!sectionConfig || parseInt(sectionConfig.max_items, 10) <= 1) return;

    const selectedItems = sectionProducts.querySelectorAll(
      ".bndlr-sectioned-status-box-product"
    );
    const counter = section.querySelector(".bndlr-sectioned-section-counter");

    if (counter) {
      counter.textContent = ` (${selectedItems.length}/${sectionConfig.max_items})`;
    }
  });
}
